import { createTheme } from "@mui/material"
import { blue, pink } from "@mui/material/colors";

import './customTypographies';


export const lightTheme = createTheme({
  palette: {
    primary: {
      main: "#1679AB",
      dark: "#074173",
      light: "#A0DEFF",
      contrastText: '#FFFFFF',
    },

    secondary: {
      main: "#FF5F00",
      dark: "#dc4e27",
      light: "#FFE0B5",
      contrastText: '#FFFFFF',
    },


    background: {
      paper: '#F6F5F2',
      default: '#D3D3D3',
     
    }



  },
  typography: {

    subtitle1: {
      fontSize: 18,
      fontWeight: 500,
      color: '#000000',
      //,color:  "#1679AB",
    },
    body0: {
      fontSize: 12,
      fontWeight: 400,
      color: '#000000',
    },
    body1: {
      fontSize: 15,
      fontWeight: 500,
      color: '#000000',
      
    },   
    body2: {
      fontSize: 15,
      fontWeight: 300,
      color: '#000000',
    },
   


    button: {
      //fontStyle: 'italic',
    },
  },
}); 